export const QUERY_KEYS = {
  AUTH_REFRESH: 'auth-refresh',
};

export const ACCESS_TOKEN_DURATION = 50000;

export const API_AUTH_APP_CODE = 'BO';
export const API_AUTH_BASE = import.meta.env.VITE_AUTH_API_BASE || 'https://auth.storetest.sensei.tech';
export const API_PATH_AUTH_REFRESH = '/refresh';
export const API_PATH_AUTH_LOGIN = '/login';
export const API_PATH_AUTH_RESET_PASSWORD = '/reset-password';
export const API_PATH_AUTH_SET_PASSWORD = '/set-new-password';
export const API_PATH_USERS_FINISH_REGISTRATION = '/users/finish-user-with-email-registration';
